<template>
  <div class="navbar-mobile">
    <div class="navbar-mobile-navigation" :class="[isNavOpen && 'open']">
      <div class="navbar-mobile-navigation-header">
        <img src="../assets/logo-color.svg" alt="ricoma logo" class="w-48" />
        <span class="navbar-mobile-navigation-close" @click="$emit('close')">
          <VSvgIcon name="close" width="40" height="40" />
        </span>
      </div>
      <div>
        <AdminNavLinks v-if="isAdmin" />
        <NavLinks v-else />
      </div>
    </div>

    <div class="navbar-mobile-overlay" :class="[isNavOpen && 'open']"></div>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

import NavLinks from '@/components/customer/NavLinks';
import AdminNavLinks from '@/components/admin/NavLinks';

export default {
  name: 'NavBarMobile',
  components: { NavLinks, AdminNavLinks, VSvgIcon },
  props: {
    isAdmin: {
      type: Boolean,
      required: true,
      default: false,
    },
    isNavOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>
